<!-- Adapted from YesPlayMusic v0.4.11, MIT (qier222). components/Navbar.vue -->
<template>
  <div><nav :aria-label="workspace.appearance==='salt'?'顶部导航':'主导航'" :class="{'salt-topbar':workspace.appearance==='salt','apple-compact-search':compactAppleSearch,'compact-mobile-nav':compactMobile,'ypm-mobile-nav':workspace.appearance==='yesplaymusic' && compactMobile,'mobile-search-open':compactMobile && mobileSearchOpen || compactAppleSearch && mobileSearchOpen}">
    <button v-if="workspace.appearance==='salt'" id="salt-navigation-trigger" class="salt-title-button mobile-navigation-toggle" type="button" aria-label="打开导航菜单" aria-controls="salt-sidebar" aria-haspopup="dialog" :aria-expanded="String(navigationUI.open)" @click="closeSearch();openNavigation()"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16" /></svg></button>
    <div @click.capture="closeSearch" class="navigation-buttons" v-if="workspace.appearance==='salt'"><button type="button" class="salt-title-button" aria-label="后退" @click="$router.back()"><svg-icon icon-class="arrow-left"/></button><button type="button" class="salt-title-button" aria-label="前进" @click="$router.forward()"><svg-icon icon-class="arrow-right"/></button></div><div v-else class="navigation-buttons"><button-icon aria-label="后退" @click.native="$router.back()"><svg-icon icon-class="arrow-left" /></button-icon><button-icon aria-label="前进" @click.native="$router.forward()"><svg-icon icon-class="arrow-right" /></button-icon></div>
    <div v-if="workspace.appearance!=='salt'" class="navigation-links"><router-link to="/" data-nav="home" aria-label="首页" title="首页" :class="{active:$route.name==='home'}"><svg-icon class="mobile-nav-icon" icon-class="home"/><span>首页</span></router-link><router-link to="/explore" data-nav="explore" aria-label="发现" title="发现" :class="{active:$route.name==='explore'}"><svg-icon class="mobile-nav-icon" icon-class="explore"/><span>发现</span></router-link><router-link to="/library" data-nav="library" aria-label="音乐库" title="音乐库" :class="{active:$route.name==='library'}"><svg-icon class="mobile-nav-icon" icon-class="library"/><span>音乐库</span></router-link></div>
    <div v-if="workspace.appearance==='salt'" class="salt-mobile-context" :class="{'platform-context':workspace.mode==='online'}" :inert="mobileSearchOpen" :aria-hidden="String(mobileSearchOpen)" aria-live="polite">
      <template v-if="workspace.mode==='online'"><span class="platform-indicator" :class="{'at-qq':catalogSettings.platform==='tx'}" aria-hidden="true"/><SaltButton v-for="platform in catalogPlatforms" :key="platform.id" style-type="plain" :aria-pressed="String(catalogSettings.platform===platform.id)" :class="{active:catalogSettings.platform===platform.id}" @click="selectCatalogPlatform(platform.id)">{{ platform.name }}</SaltButton></template>
      <span v-else>{{ mobileContextLabel }}</span>
    </div>
    <div class="right-part"><button v-if="workspace.appearance==='salt' || workspace.appearance==='apple' || compactMobile" type="button" class="salt-title-button mobile-search-toggle" :aria-label="mobileSearchOpen?'关闭搜索':'打开搜索'" :aria-expanded="String(mobileSearchOpen)" @click="toggleMobileSearch"><svg v-if="!mobileSearchOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 5 5"/></svg><svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button><select v-if="workspace.showSearchScope && (!(compactAppleSearch || compactMobile) || mobileSearchOpen)" v-model="search.source" class="search-scope-select" aria-label="搜索范围" title="搜索范围" @change="changeSearchSource"><option value="all">综合</option><option value="local">本地</option><option value="network">网络</option></select><div class="search-box" :inert="(compactMobile || compactAppleSearch) && !mobileSearchOpen" :class="{'mobile-expanded':mobileSearchOpen}"><div class="container" :class="{active:inputFocus}"><svg-icon icon-class="search"/><div class="input"><input id="global-search-input" ref="searchInput" :value="search.query" type="search" :placeholder="searchPlaceholder" :aria-label="searchPlaceholder" autocomplete="off" :aria-expanded="String(search.open)" aria-controls="global-search-overlay" @input="input" @compositionstart="composeStart" @compositionend="compositionEnd" @keydown="keydown" @focus="focus" @blur="inputFocus=false" /></div><button v-if="workspace.appearance==='apple' && search.open && !compactMobile" class="apple-search-dismiss" type="button" aria-label="关闭搜索" title="关闭搜索，保留输入" @click="closeAppleSearch"><svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="m5 5 10 10M15 5 5 15" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button></div></div><slot name="before-avatar" /><button type="button" class="avatar" aria-label="用户菜单" :title="site.user ? (site.user.nickname || site.user.username) + ' · 账号与登录' : '账号与登录'" aria-haspopup="menu" @click="closeSearch();$refs.userProfileMenu.openMenu($event)"><SiteUserAvatar :src="site.user?.avatarUrl || ''"/></button></div>
  </nav><ContextMenu ref="userProfileMenu"><button class="item" role="menuitem" data-nav="settings" @click="$router.push('/settings')"><svg-icon icon-class="settings" />设置</button><button class="item" role="menuitem" @click="$router.push('/account')"><svg-icon icon-class="login" />账号与登录</button><button v-if="!independentProduct" class="item" role="menuitem" @click="switchAppearance"><svg-icon icon-class="list"/>{{workspace.appearance==='salt'?'切换至 YesPlayMusic 外观':'切换至 Salt 外观'}}</button></ContextMenu></div>
</template>
<script>
import ButtonIcon from './ButtonIcon.vue';
import SaltButton from '../salt/ui/SaltButton.vue';
import {workspace,setAppearance,navigationUI,openNavigation} from '../workspace';
import {independentProduct} from '../product-flavor';
import {runtime} from '../bridge';
import ContextMenu from './ContextMenu.vue';
import SiteUserAvatar from './SiteUserAvatar.vue';
import {siteAccount} from '../site-account';
import {search,setQuery,submitSearch,composeStart,composeEnd,closeSearch} from '../search';
import { patchWorkspacePageState } from '../workspace-view-state';
export default {name:'Navbar',props:{appleCompactSearch:Boolean},components:{ButtonIcon,SaltButton,ContextMenu,SiteUserAvatar},data(){return{workspace,navigationUI,search,site:siteAccount,independentProduct,catalogSettings:runtime.catalogSettings,catalogPlatforms:[{id:'wy',name:'网易云音乐'},{id:'tx',name:'QQ音乐'}],inputFocus:false}},computed:{compactAppleSearch(){return workspace.appearance==='apple' && this.appleCompactSearch && !navigationUI.mobile;},compactMobile(){return navigationUI.mobile;},mobileSearchOpen:{get(){return search.mobileExpanded;},set(value){search.mobileExpanded=value;}},searchPlaceholder(){return workspace.appearance!=='salt'?'搜索歌曲、艺术家或专辑':workspace.mode==='local'?'搜索本地音乐':workspace.mode==='online'?'搜索 QQ音乐、网易云音乐':'搜索全部音乐';},mobileContextLabel(){if(this.$route.name==='library'){const labels={songs:'歌曲',albums:'专辑',artists:'艺术家',playHistory:'最近播放',folders:'原始文件夹',manage:'音乐库管理',cloudDisk:'云盘与连接'};return labels[this.$route.query.tab]||'音乐库';}if(this.$route.name==='account')return '账号与登录';if(this.$route.name==='settings')return '设置';if(this.$route.name==='explore')return '发现音乐';if(this.$route.name==='cloud')return '我的云盘';return this.$route.name==='home'?'首页':'Simple Music';}},watch:{$route(){this.mobileSearchOpen=false;},mobileSearchOpen(open){if(open||!this.compactAppleSearch)return;const active=document.activeElement;if(active!==this.$refs.searchInput&&!active?.closest('#global-search-overlay'))return;this.$nextTick(()=>{if(!this.mobileSearchOpen)this.restoreSearchFocus();});}},methods:{openNavigation,closeSearch,closeAppleSearch(){closeSearch();this.mobileSearchOpen=false;this.$nextTick(()=>this.restoreSearchFocus());},restoreSearchFocus(){const toggle=this.$el.querySelector('.mobile-search-toggle');const target=toggle?.getClientRects().length?toggle:document.querySelector('.apple-nav-search');target?.focus({preventScroll:true});},switchAppearance(){if(independentProduct)return;setAppearance(workspace.appearance==='salt'?'yesplaymusic':'salt');},changeSearchSource(){if(search.query.trim())void submitSearch(false);},selectCatalogPlatform(platform){runtime.setCatalogPlatform(platform);if(workspace.appearance==='salt')patchWorkspacePageState(workspace.mode,'explore',{platform:runtime.catalogSettings.platform});},toggleMobileSearch(){this.mobileSearchOpen=!this.mobileSearchOpen;if(this.mobileSearchOpen)this.$nextTick(()=>this.$refs.searchInput?.focus());else{closeSearch();this.$refs.searchInput?.blur();this.$nextTick(()=>this.restoreSearchFocus());}},composeStart,input(event){if(event.isComposing||search.composing){search.query=event.target.value;return;}setQuery(event.target.value);},compositionEnd(event){composeEnd(event.target.value);},keydown(event){if(event.isComposing||search.composing||event.keyCode===229){if(event.key==='Escape')event.stopPropagation();return;}if(event.key==='Escape'){event.preventDefault();event.stopPropagation();closeSearch();this.mobileSearchOpen=false;event.target.blur();if(this.compactMobile || workspace.appearance==='apple')this.$nextTick(()=>this.restoreSearchFocus());}if(event.key==='Enter'&&!event.isComposing&&!search.composing&&event.keyCode!==229){event.preventDefault();void submitSearch();}},focus(){this.inputFocus=true;if(!search.query.trim())return;if(search.results.length || Object.values(search.entities).some(group=>group.results.length))search.open=true;else setQuery(search.query);}}};
</script>
<style lang="scss" scoped>
nav {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: {
    right: 10vw;
    left: 10vw;
  }
  backdrop-filter: saturate(180%) blur(20px);

  background-color: var(--color-navbar-bg);
  z-index: 100;
  -webkit-app-region: drag;
}

@media (max-width: 1336px) {
  nav {
    padding: 0 max(5vw, 90px);
  }
}

@supports (-moz-appearance: none) {
  nav {
    background-color: var(--color-body-bg);
  }
}

nav.has-custom-titlebar {
  padding-top: 20px;
  -webkit-app-region: no-drag;
}

.navigation-buttons {
  flex: 1;
  display: flex;
  align-items: center;
  .svg-icon {
    height: 24px;
    width: 24px;
  }
  button {
    -webkit-app-region: no-drag;
  }
}
@media (max-width: 970px) {
  .navigation-buttons {
    flex: unset;
  }
}

.navigation-links {
  flex: 1;
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  user-select: none;
  a {
    -webkit-app-region: no-drag;
    font-size: 18px;
    font-weight: 700;
    text-decoration: none;
    border-radius: 6px;
    padding: 6px 10px;
    color: var(--color-text);
    transition: 0.2s;
    -webkit-user-drag: none;
    margin: {
      right: 12px;
      left: 12px;
    }
    &:hover {
      background: var(--color-secondary-bg-for-transparent);
    }
    &:active {
      transform: scale(0.92);
      transition: 0.2s;
    }
  }
  a.active {
    color: var(--color-primary);
  }
}

.search {
  .svg-icon {
    height: 18px;
    width: 18px;
  }
}

.search-box {
  display: flex;
  justify-content: flex-end;
  -webkit-app-region: no-drag;

  .container {
    display: flex;
    align-items: center;
    height: 32px;
    background: var(--color-secondary-bg-for-transparent);
    border-radius: 8px;
    width: 200px;
  }

  .svg-icon {
    height: 15px;
    width: 15px;
    color: var(--color-text);
    opacity: 0.28;
    margin: {
      left: 8px;
      right: 4px;
    }
  }

  input {
    font-size: 16px;
    border: none;
    background: transparent;
    width: 96%;
    font-weight: 600;
    margin-top: -1px;
    color: var(--color-text);
  }

  .active {
    background: var(--color-primary-bg-for-transparent);
    input,
    .svg-icon {
      opacity: 1;
      color: var(--color-primary);
    }
  }
}

[data-theme='dark'] {
  .search-box {
    .active {
      input,
      .svg-icon {
        color: var(--color-text);
      }
    }
  }
}

.right-part {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .avatar {
    user-select: none;
    height: 30px;
    width: 30px;
    min-width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 0;
    border: 0;
    color: var(--color-secondary);
    background: var(--color-secondary-bg);
    margin-left: 12px;
    vertical-align: middle;
    border-radius: 50%;
    cursor: pointer;
    -webkit-app-region: no-drag;
    -webkit-user-drag: none;
    .site-user-avatar {
      width: 100%;
      height: 100%;
    }
    &:hover {
      filter: brightness(80%);
    }
  }
  .search-button {
    display: none;
    -webkit-app-region: no-drag;
  }
}
.search-scope-select { flex:0 0 auto; width:58px; min-height:30px; margin-left:8px; padding:4px 5px; border:0; border-radius:7px; background:var(--color-secondary-bg-for-transparent); color:var(--color-text); font:inherit; font-size:12px; font-weight:600; }
.search-scope-select:focus-visible { outline:2px solid var(--color-primary); outline-offset:2px; }
#app.apple-shell.salt-mobile-layout nav.mobile-search-open .search-scope-select { position:absolute; top:calc(env(safe-area-inset-top,0px) + 8px); left:max(56px,env(safe-area-inset-left,0px)); width:58px; min-height:36px; margin:0; }
#app.apple-shell.salt-mobile-layout nav.mobile-search-open:has(.search-scope-select) .search-box { left:calc(max(56px,env(safe-area-inset-left,0px)) + 66px); }
</style>

<style scoped>.salt-mobile-context,.mobile-search-toggle{display:none;}</style>

<style scoped>.input{min-width:0;width:100%}.search-box input{box-sizing:border-box;max-width:100%}.settings-avatar{width:32px;padding:5px;color:var(--color-text)}.settings-avatar .svg-icon{width:22px;height:22px}@media(max-width:760px){nav{padding:0 16px}.navigation-buttons{display:none}.navigation-links{justify-content:flex-start;flex:0;white-space:nowrap}.navigation-links a{font-size:16px;margin:0 4px;padding:6px}.right-part{min-width:0}.search-box{min-width:0}.search-box .container{width:140px;max-width:100%}}@media(max-width:420px){.search-box .container{width:105px}.right-part .avatar{margin-left:6px}}</style>


<style scoped>
#app.apple-shell .apple-search-dismiss{display:grid;place-items:center;flex:none;width:28px;height:28px;margin-right:8px;padding:5px;border:0;border-radius:5px;background:transparent;color:var(--apple-muted);cursor:pointer}.apple-search-dismiss svg{width:18px;height:18px}#app.apple-shell .apple-search-dismiss:hover{background:#8882}#app.apple-shell #global-search-input::-webkit-search-cancel-button{-webkit-appearance:none}
</style>

<style lang="scss" scoped>
.mobile-nav-icon{display:none;}
/* A collapsed phone search must not leave its scope control floating above the page title. */
#app .salt-topbar.compact-mobile-nav .right-part{top:calc(env(safe-area-inset-top,0px) + 6px);}
#app .salt-topbar.compact-mobile-nav.mobile-search-open .search-scope-select{flex:0 0 66px;width:66px;min-height:44px;margin:0 4px 0 0;padding:4px;font-size:16px;}
#app .salt-topbar.compact-mobile-nav .search-box{flex:1 1 0;}
#app .salt-topbar.compact-mobile-nav .search-box input{font-size:16px;}
nav.ypm-mobile-nav{
 padding:0 8px;gap:4px;box-sizing:border-box;
 .navigation-buttons{display:none;}
 .navigation-links{flex:0 0 auto;gap:2px;}
 .navigation-links a{display:grid;place-items:center;width:44px;height:44px;box-sizing:border-box;padding:10px;margin:0;}
 .navigation-links a span{display:none;}
 .mobile-nav-icon{display:block;width:22px;height:22px;}
 .right-part{flex:1 1 0;min-width:0;gap:4px;}
 .mobile-search-toggle{display:grid;place-items:center;flex:none;width:44px;height:44px;padding:10px;border:0;background:transparent;color:inherit;}
 .mobile-search-toggle svg{width:22px;height:22px;}
 .avatar{width:44px;min-width:44px;height:44px;margin:0;padding:7px;}
 .search-box{display:none;}
 &.mobile-search-open{
  .navigation-links,.avatar{display:none;}
  .right-part{justify-content:stretch;}
  .search-scope-select{flex:0 0 64px;width:64px;height:44px;margin:0;padding:4px;font-size:16px;}
  .search-box{display:flex;flex:1 1 0;min-width:0;}
  .search-box .container{width:100%;min-width:0;height:44px;}
  .search-box input{font-size:16px;}
  .mobile-search-toggle{order:3;}
 }
}
</style>
